import React from 'react';
import { motion } from 'framer-motion';
export function Problem() {
  return <section className="py-24 px-6 bg-charcoal-800 relative bg-noise-overlay" data-id="element-108">
      <div className="container mx-auto max-w-4xl text-center" data-id="element-109">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-110">
          <h2 className="text-3xl md:text-5xl font-serif text-cream mb-8 leading-tight" data-id="element-111">
            ¿Cansado de barberías que te tratan{' '}
            <br className="hidden md:block" data-id="element-112" />
            <span className="text-gold-400 italic" data-id="element-113">como un número más?</span>
          </h2>

          <div className="w-16 h-[1px] bg-gold-500/50 mx-auto mb-10" data-id="element-114"></div>

          <div className="space-y-6 text-lg md:text-xl text-cream-muted font-light leading-relaxed" data-id="element-115">
            <p data-id="element-116">
              La mayoría de los lugares hoy ofrecen cortes "a la carrera".
              Entras, te cortan en 15 minutos y sales sin que nadie haya
              analizado la forma de tu rostro o el crecimiento de tu barba.
            </p>
            <p className="text-cream font-medium" data-id="element-117">
              En MA Barber Studio, sabemos que tu imagen es tu carta de
              presentación. Por eso, aquí el tiempo se detiene para dar paso a
              la perfección.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}